// components
import CommonActionModal from "../Common/CommonActionModal";
import SliceDetail from "./SliceDetail";

// icons
import SummarizeIcon from '@mui/icons-material/Summarize';
import WebAssetIcon from '@mui/icons-material/WebAsset';


class SliceDetailModal extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: WebAssetIcon,
            buttonColor: 'neutral',
            ready: true,
            flat: true,
            width: this.props.slice.pre_week_completed?'calc(80vw)':'calc(60vw)',
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: 'Срез',
            modalIcon: SummarizeIcon,
            mainComponent: SliceDetail,
            mainComponentProps: {
                slice: this.props.slice,
                callBack: this.props.callBack,
                showOpportunity: this.props.showOpportunity
            },
        }
    }
}

export default SliceDetailModal